export default __webpack_public_path__ + "static/media/obs.6709d07d.png";